import {
  AggregateMap as GlobalAggregateMap,
  AggregateReduce as GlobalAggregateReduce,
  TreeSelectionsReducer,
} from './common.js';

const DragInTheBlankSelectionsReducer = TreeSelectionsReducer;

export const DragInTheBlankSelectionsAggregator = info => {
  const { responses, question } = info || {};

  return (responses || []).reduce((acc, response) => {
    const { data } = response || {};
    const { choices } = question || {};
    const { value } = data || {};
    const categoryIds = Object.keys(value || {});

    if (!categoryIds || !choices) return acc;

    (categoryIds || []).forEach(categoryId => {
      const selections = acc[categoryId] || {};
      const choiceId = value[categoryId];
      const choiceCount = (selections[choiceId] || {}).count || 0;
      const choice = (choices || []).find(c => c.id === choiceId);

      acc[categoryId] = {
        ...selections,
        [choiceId]: {
          value: choice && choice.value,
          count: choiceCount + 1,
        },
      };
    });

    return acc;
  }, {});
};

export default {
  AggregateMap: GlobalAggregateMap(DragInTheBlankSelectionsAggregator),
  AggregateReduce: GlobalAggregateReduce(DragInTheBlankSelectionsReducer),
};
